import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSalesStatusQuickInfo extends Layout {
    sourceSalesStatus: DataSource;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
